// extracted by mini-css-extract-plugin
export default {"body":"body__0f1f4f7a"};